<template>
  <section>

    <b-autocomplete
        v-model="name"
        :data="filteredDataArray"
        :placeholder="placeholder"
        :icon="icon"
        :size="size"
        clearable
        :key='key'
        field="1"
        v-if="!(onlyOne && selected.length >= 1)"
        @select="option => {if (option != null ){selected.push(option); remove(option, chainData); $emit('list', selected); name ='', key = !key;}}">
      <template #empty>No results found</template>
    </b-autocomplete>
    <div v-else>
      <br/>
    </div>
    <b-field
        class="mt-3">
      <div v-if="columns">
        <b-taglist>
          <b-tag
              v-for="item in selected" :key="item.id"
              type=""
              closable
              :size="size"
              aria-close-label="Close tag"
              @close="chainData.push(item); remove(item, selected); $emit('list', selected)">
            {{ item[1] }}
          </b-tag>
        </b-taglist>
      </div>
      <div v-else>
        <div v-for="item in selected" :key="item">
          <b-tag
              type=""
              closable
              :size="size"
              aria-close-label="Close tag"
              @close="chainData.push(item); remove(item, selected); $emit('list', selected)">
            {{ item[1] }}
          </b-tag>
        </div>
      </div>
    </b-field>
  </section>

</template>

<script>
export default {
  name: 'TagAutocomplete',
  props: {
    chainData: Array,
    placeholder: String,
    icon: String,
    columns: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Array,
      default: () => []
    },
    onlyOne: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'is-small'
    }
  },
  data() {
    return {
      name: '',
      key: true,
    }
  },
  methods: {
    remove(val, list) {
      const index = list.indexOf(val)
      if (index > -1) {
        list.splice(index, 1);
      }
    },
    columnCondition(val) {
      if (this.columns) {
        return val
      } else {
        return ''
      }
    }
  },
  computed: {
    filteredDataArray() {
      return this.chainData.filter((option) => {
        return option[1]
            .toString()
            .toLowerCase()
            .indexOf(this.name.toLowerCase()) >= 0
      })
    }
  },
  mounted() {
    this.$emit('list', this.selected)
  }
}
</script>

